import Input from '@cohort/merchants/components/form/input/Input';
import type {FieldValues} from 'react-hook-form';

type UrlInputProps<T extends FieldValues> = React.ComponentProps<typeof Input<T>>;

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function UrlInput<T extends FieldValues>(props: UrlInputProps<T>): JSX.Element {
  return <Input insetPrefix="https://" {...props} type="text" />;
}
